import { render, staticRenderFns } from "./EditAgendas.vue?vue&type=template&id=3eb13970"
import script from "./EditAgendas.vue?vue&type=script&lang=js"
export * from "./EditAgendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports